import createLucideIcon from '../createLucideIcon';

const CaseSensitive = createLucideIcon('CaseSensitive', [
  ['polyline', { points: '3,15 7,7 11,15', key: '6kwx87' }],
  ['line', { x1: '4', x2: '10', y1: '13', y2: '13', key: 'f4ax0e' }],
  ['circle', { cx: '18', cy: '12', r: '3', key: '1kchzo' }],
  ['line', { x1: '21', x2: '21', y1: '9', y2: '15', key: 'vcppzq' }],
]);

export default CaseSensitive;
